import { commandApi } from 'app/apis/commandApi';
import { queryApi } from 'app/apis/queryApi';
import { mapAccountsAndConfigs } from './platform-config-slice.helper';
import { ClientIntegrationPlatformConfigState } from './platform-config.slice';
import { ActionReducerMapBuilder, AnyAction } from '@reduxjs/toolkit';

export const addFacebookExtraReducers = (
  builder: ActionReducerMapBuilder<ClientIntegrationPlatformConfigState>
) => {
  builder.addMatcher(
    commandApi.endpoints.facebookAdsAuthenticationStatus.matchFulfilled,
    (state: ClientIntegrationPlatformConfigState, action: AnyAction) => {
      const config = state.platformConfigs.find(
        (config) => config.platformType === 'FacebookAds'
      );
      if (config) {
        if (config.platformConfig.length === 0) {
          config.platformConfig = [
            {
              configIdentifier: '',
              queryFilters: []
            }
          ];
        }
        config.accountLookUps = [...action.payload.accountIdLookups];
      } else {
        state.platformConfigs.push({
          platformType: 'FacebookAds',
          platformConfig: [
            {
              configIdentifier: '',
              queryFilters: []
            }
          ],
          accountLookUps: [...action.payload.accountIdLookups]
        });
      }
    }
  );

  builder.addMatcher(
    queryApi.endpoints.getClientIntegration.matchFulfilled,
    (state: ClientIntegrationPlatformConfigState, action: AnyAction) => {
      const facebookPlatformConfig = state.platformConfigs.find(
        (config) => config.platformType === 'FacebookAds'
      );

      if (!facebookPlatformConfig) return;

      const { mappedPlatformConfigs } = mapAccountsAndConfigs(
        facebookPlatformConfig.accountLookUps,
        action.payload.platformConfigs ?? []
      );

      facebookPlatformConfig.platformConfig = mappedPlatformConfigs?.length
        ? mappedPlatformConfigs
        : [
            {
              configIdentifier: '',
              queryFilters: []
            }
          ];
    }
  );
};
